import './welcomePage.scss';
// import { ReactComponent as BenGurionIcon } from '../assets/ben-gurion-icon.svg';
import UniCreditLogo from '../assets/uni-logo-2.png';
import BenGurionIcon from '../assets/ben-gurion-icon.png';
import { InputField } from '../cmps/InputField';
import { TagsDropdown } from '../cmps/tags/tagsDropdown';
import { allTagsAtom } from '../atoms';
import { useAtom } from 'jotai';
import TagList from '../cmps/tags/newTags';

const parseEmailsAndBold = (text) => {
  if (!text) return '';

  // First handle bold text
  const parts = text.split(/(\*\*\*\*.*?\*\*\*\*)/g);
  
  return parts.map((part, index) => {
    if (part.startsWith('****') && part.endsWith('****')) {
      const content = part.slice(4, -4);
      return <strong key={index}>{content}</strong>;
    }

    // Process regular text for emails
    const words = part.split(/(\s+)/);
    return words.map((word, i) => {
      // Check if word is an email
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+$/i.test(word)) {
        return (
          <a
            key={`${index}-${i}`}
            href={`mailto:${word}`}
            onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
            onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
            style={{
              direction: 'ltr',
              marginLeft: '5px',
              fontWeight: 'bold',
              textDecoration: 'none',
            }}
          >
            {word}
          </a>
        );
      }
      return word;
    });
  });
};

export const WelcomePage = ({ input, setInput, getAns, placeHolder, firstMessage, isEnglishUi }) => {
  const isSmartphone = window.matchMedia('(max-width: 600px)').matches;
  const [allTags] = useAtom(allTagsAtom);
  const messageFromDB = firstMessage.trim();

     
return (
  <div className="welcome-page" style={isEnglishUi ? { direction: 'ltr' } : {}}>
    <div className="welcome-container" style={{ gap: isSmartphone ? '' : '20px' }}>
      <div className="welcome-image" style={{ marginTop: isSmartphone ? '' : '2.3%' }}>
        <img src={BenGurionIcon} style={{ cursor: 'auto' }} title="תמונה של דוד בן גוריון" />
      </div>
      <div className="welcome-message" style={{ display: 'flex', flexDirection: 'column' }}>
        {(() => {
          const paragraphs = messageFromDB.split(/\n\n+/).map(p => p.trim()).filter(Boolean);
          const [firstParagraph, ...restParagraphs] = paragraphs;
          
          // Get all paragraphs except the last one
          const regularParagraphs = restParagraphs.slice(0, -1);
          
          // Get the last paragraph separately (email paragraph)
          const lastParagraph = restParagraphs[restParagraphs.length - 1];
          
          
          return (
            <>
              {/* First paragraph as header */}
              <p className="first-message-header" style={{ margin: 0 }}>
                {parseEmailsAndBold(firstParagraph)}
              </p>
              
              {/* Regular paragraphs */}
              {regularParagraphs.map((paragraph, index) => (
                <p 
                  key={index} 
                  className="first-message" 
                  style={{ paddingBottom: isSmartphone ? '' : '10px', whiteSpace: 'pre-line' }}
                >
                  {paragraph.split('\n').map((line, lineIndex) => (
                      <span key={lineIndex}>
                        {lineIndex > 0 && <br />}
                        {parseEmailsAndBold(line)}
                      </span>
                    ))}
                </p>
              ))}
              
              {/* Last paragraph with the email */}
              {lastParagraph && (
                <p 
                  className="first-message" 
                  style={{ paddingBottom: isSmartphone ? '' : '10px', whiteSpace: 'pre-line' }}
                >
                  {parseEmailsAndBold(lastParagraph)}
                  .
                </p>
              )}
            </>
          );
        })()}
      </div>
      </div>
      {allTags && typeof allTags === 'object' && Object.keys(allTags).length > 0 && <TagList />}
      <InputField
        isEnglishUi={isEnglishUi}
        placeHolder={placeHolder}
        getAns={getAns}
        input={input}
        setInput={setInput}
      />
      {allTags.length > 0 && <TagsDropdown />}
      <div
        className="credit-container"
        style={
          isSmartphone
            ? {
                left: '8%',
                width: ' 88%',
                position: 'fixed',
                bottom: '0px',
                marginBottom: '5px',
                flexDirection: 'space-between',
                justifyContent: 'space-between',
              }
            : {
                left: '45%',
                position: 'fixed',
                bottom: '0px',
                left: '0px',
                marginBottom: '10px',
                marginLeft: '15px',
                flexDirection: 'column',
              }
        }
      >
        {isSmartphone && (
          <img src={UniCreditLogo} style={{ height: isSmartphone ? '30px' : '45px', width: 'auto' }} />
        )}
        <div className="bottom-credit" style={{ marginTop: isSmartphone ? '7px' : '' }}>
          <h4 style={{ fontSize: isSmartphone ? '' : '14px' }}>
            Powered By{' '}
            <a href="https://jeen.ai" target="_blank" className="jeen-link" title="jeen.ai">
              Jeen.AI
            </a>
        </h4>
        <h4 style={{ fontSize: isSmartphone ? '6px' : '10px', opacity: '0.5' }}>
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a> apply
        </h4>
        </div>
      </div>
    </div>
  );
};
